"use client";

import Link from "next/link";

import PostCardImg from "../PostCardImg";
import Badges from "../Badges";
const styles = new Proxy({"PostCard":"PostCard-84859","CardBody":"CardBody-84859","Tags":"Tags-84859","CardTitle":"CardTitle-84859","CardExcerpt":"CardExcerpt-84859","CardFooter":"CardFooter-84859","AuthorDate":"AuthorDate-84859","AuthorName":"AuthorName-84859","Date":"Date-84859","ReadMore":"ReadMore-84859"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import type { FormattedPost } from "@/lib/blog";

const PostCard = ({
  post: { featuredImage, title, scheduledAt, author, excerpt, link, tags },
  isFirst,
  wider,
}: {
  post: FormattedPost;
  isFirst?: boolean;
  className?: string;
  router?: any;
  wider?: boolean;
}) => {
  return (
    <div className={`my-3 ${wider ? "col-lg-5" : "col-lg-4"}`}>
      <div className={styles.PostCard}>
        <PostCardImg post={{ featuredImage, link }} priority={isFirst} />

        <div className={styles.CardBody}>
          <div className={styles.Tags}>
            <Badges badges={tags} limit={3} />
          </div>

          <h3 className={styles.CardTitle}>
            <Link href={link}>
              <span
                dangerouslySetInnerHTML={{ __html: title }}
                suppressHydrationWarning
              />
            </Link>
          </h3>

          <p className={styles.CardExcerpt}>{excerpt}</p>

          <div className={styles.CardFooter}>
            <div className={styles.AuthorDate}>
              <span className={styles.AuthorName}>{author.name}</span>
              <span className={styles.Date}>{scheduledAt}</span>
            </div>
            <Link href={link} className={styles.ReadMore}>
              Read more
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostCard;
